import { AlertType, Alert, Poll } from '@sdk/API';

export const AlertTitleTemplate: Record<AlertType, string> = {
  POPUP: 'POPUP msg',
  EVENT: 'Event msg',
  PROMOTION: 'Promotion',
  POLL_RESET: 'Poll has been reset',
  POLL_VOTE_CLOSED: 'Poll has been cancelled',
  POLL_PLEDGING_CLOSED: 'Poll has been cancelled',
  POLL_END: 'Poll ended',
  POLL_PLEDGING1: 'Poll pledge period started',
  POLL_PLEDGING2: 'Poll pledge period ended',
};

export const AlertMessageTemplate: Record<AlertType, string> = {
  POPUP: 'POPUP', // TODO
  EVENT: 'Event msg',
  PROMOTION: 'Promotion',
  POLL_RESET: '{owner} has made changes to the Poll. Vote(s) have been reset.',
  POLL_VOTE_CLOSED: '{owner}’s has cancelled the poll.',
  POLL_PLEDGING_CLOSED: '{owner}’s has cancelled the poll.',
  POLL_END: '{owner}’s Poll has ended. Click here to view the Poll Results.',
  POLL_PLEDGING1:
    '{owner}’s Poll has ended. Click here to view the Poll Results and begin Pledging!',
  POLL_PLEDGING2:
    'Pledging for {owner}’s Poll has ended. Click here to view the Pledge Results.',
};

export interface AlertDetail extends Alert {
  poll: Poll;
}
